var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-scroll h-100" }, [
    !_vm.is_load
      ? _c(
          "div",
          { staticClass: "loader_calendar w-100 text-center pt-5 mt-5" },
          [
            _c("sync-loader", {
              attrs: { loading: true, color: "#7a59ad", size: "10px" },
            }),
          ],
          1
        )
      : _c(
          "ul",
          { staticClass: "notification" },
          _vm._l(this.data, function (chat) {
            return _c("li", { staticClass: "unread" }, [
              _c(
                "a",
                {
                  staticClass: "d-flex align-items-center",
                  attrs: { href: chat.url },
                },
                [
                  _c("span", { staticClass: "status mr-2" }, [
                    _c("span", {
                      staticClass:
                        "profile-image rounded-circle d-inline-block",
                      style: {
                        "background-image": "url(" + chat.user.medium_img + ")",
                        "background-size": "cover",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "d-flex flex-column flex-1 ml-1" },
                    [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(
                          " " +
                            _vm._s(chat.user_name) +
                            "\n                        "
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "badge badge-primary fw-n position-absolute pos-top pos-right mt-1",
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(chat.number) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "msg-a fs-sm" }, [
                        _vm._v("Повідомлення"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "msg-b fs-xs" }, [
                        _vm._v(_vm._s(chat.message)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fs-nano text-muted mt-1" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(chat.added) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ])
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }